import { Component, inject, signal, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext } from '@eforall/dashboard';
import { AppService } from '../../../services';
import { NotesEditorPart } from './notes-editor/notes-editor.part';

export interface NotesEditorDialogData {
	noteId?: number,
	personId?: number,
	accVentureId?: number
}
@Component({
	selector: 'notes-editor-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		NotesEditorPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './notes-editor.dialog.html'
})

export class NotesEditorDialog {

	public dialogRef = inject(MatDialogRef<NotesEditorDialog>);
	public dialogContext: DialogContext<NotesEditorDialogData> = inject(MAT_DIALOG_DATA);

	app = inject(AppService);

	public actions: DialogAction[] = [{
		id: 'close',
		cssClass: signal(undefined),
		enabled: signal(true),
		visible: signal(true),
		text: signal('Close'),
		linkType: 'no-action',
		willCloseDialog: true,
	}];

}